function SentinelMenu(sentinelService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            active: "="
        },
		template: require('./sentinel-menu.html'),

        link: function (scope, element) {

            scope.setActive = function (view) {
                scope.active = view;
                angular.element(element).find(".btn").removeClass('active');
                angular.element(element).find(".menu-item-" + scope.active).addClass("active");

                sentinelService.setActiveTab(scope.active);
            };

            (function () {
                scope.active = sentinelService.getActiveTab();
                scope.setActive(scope.active);
            })();
        }
    }
}

angular.module('sentinel').directive('sentinelMenu', ['sentinelService', SentinelMenu]);
